import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { greeting, contactPageData } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;
const AddressData = contactPageData.addressSection;

class Contact extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="contact-main">
        <Header theme={theme} />
        <div className="basic-contact">
          <Fade bottom duration={1000} distance="40px">
            <div className="contact-heading-div">
              <div className="contact-heading-img-div">
                <img
                  src={require(`../../assets/images/${ContactData["profile_image_path"]}`)}
                  alt="Profile"
                />
              </div>
              <div className="contact-heading-text-div">
                <h1
                  className="contact-heading-text"
                  style={{ color: theme.text }}
                >
                  {ContactData["title"]}
                </h1>
                <p
                  className="contact-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {ContactData["description"]}
                </p>
                <SocialMedia theme={theme} />
                <div className="resume-btn-div">
                  <Button
                    text="See My Resume"
                    newTab={true}
                    href={greeting.resumeLink}
                    theme={theme}
                  />
                </div>
              </div>
            </div>
          </Fade>

          {/* Contact Information Section */}
          <Fade bottom duration={1000} distance="40px">
            <div className="address-heading-div">
              <div className="contact-info-wrapper">
                <h1 className="address-heading-text" style={{ color: theme.text }}>
                  {AddressData.title}
                </h1>
                <p
                  className="address-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {AddressData.subtitle}
                </p>
                
                <div className="contact-details">
                  <div className="contact-item">
                    <h3 style={{ color: theme.text }}>📧 Email</h3>
                    <a 
                      href={`mailto:${AddressData.email}`}
                      style={{ color: theme.secondaryText }}
                    >
                      {AddressData.email}
                    </a>
                  </div>
                  
                  <div className="contact-item">
                    <h3 style={{ color: theme.text }}>📱 Phone</h3>
                    <a 
                      href={`tel:${AddressData.phone}`}
                      style={{ color: theme.secondaryText }}
                    >
                      {AddressData.phone}
                    </a>
                  </div>
                  
                  <div className="contact-item">
                    <h3 style={{ color: theme.text }}>📍 Location</h3>
                    <p style={{ color: theme.secondaryText }}>
                      {AddressData.locality}, {AddressData.region}, {AddressData.country}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Contact;